import { render } from "./SubcategoryTagList.vue?vue&type=template&id=2cc47f32"
import script from "./SubcategoryTagList.vue?vue&type=script&lang=js"
export * from "./SubcategoryTagList.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__